"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaForAdminEntity = void 0;
class MediaForAdminEntity {
    mediaType;
    /**
     * @deprecated
     */
    _id;
    id;
    title;
    description;
    duration;
    /**
     * @deprecated
     */
    emit_date;
    /**
     * @deprecated
     */
    price;
    /**
     * @deprecated
     */
    currency;
    /**
     * @deprecated
     */
    fees;
    /**
     * @deprecated
     */
    ratings;
    video;
    audio;
    /**
     * @deprecated
     */
    tweet;
    message;
    image;
    web;
    pdf;
    /**
     * @deprecated
     */
    cams;
    stream;
    /**
     * @deprecated
     */
    direct;
    /**
     * @deprecated
     */
    direct_webcam;
    /**
     * @deprecated
     */
    social;
    qr;
    admefy_tv;
    highlighted;
    is_archive;
    published;
    /**
     * @deprecated
     */
    record;
    /**
     * @deprecated
     */
    vrmefy;
    offlineCapability;
    /**
     * @deprecated
     */
    thumbnail;
    owner;
    /**
     * @deprecated
     */
    allowed_users;
    /**
     * @deprecated
     */
    fork_from;
    /**
     * @deprecated
     */
    comments;
    canRemove;
    updatedAt;
    createdAt;
}
exports.MediaForAdminEntity = MediaForAdminEntity;
